export enum InputType {
  Dropdown = 'dropdown',
  TextField = 'text-field',
  TextArea = 'text-area',
}
